import MenuSeats from './MenuSeats';

export default MenuSeats;
